import styled from "styled-components";
import { Radio, Select, Modal } from "antd";
import { COLORS, WEIGHT } from "../../../../layout/theme";

export const Inner = styled.div`
	& .noBackground,
	& .noBackground:hover {
		background-color: ${COLORS.White} !important;
		border: none;
	}
`;

export const Filters = styled.div`
	margin: 20px 0;

	& button {
		padding: 0 !important;
	}
`;

export const RadioOptions = styled.div`
	margin-bottom: 20px;
`;

export const AntdRadioButton = styled(Radio.Button)`
	border: none;
	font-weight: ${WEIGHT.Bold};
`;

export const AntdSelect = styled(Select)`
	border: none;
	font-weight: ${WEIGHT.SemiBold};
	min-width: 150px;
`;

export const AntdOption = styled.div`
	border: none;
	font-weight: ${WEIGHT.SemiBold};
	color: ${COLORS.Grey};
`;

export const PreviewImage = styled.img`
	width: 150px;
	height: 150px;
	object-fit: contain;
`;

export const UserAvatar = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 999px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 14px;
	font-weight: 800;
	background: ${(props) => props.bg || "#EEF2FF"};
	color: ${(props) => props.color || "#4338CA"};
	text-transform: uppercase;
`;

export const UserPhoto = styled.img`
	width: 40px;
	height: 40px;
	border-radius: 999px;
	object-fit: cover;
	display: block;
`;

export const RoleTag = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 5px 12px;
	border-radius: 999px;
	font-size: 12px;
	font-weight: 800;
	line-height: 1;
	white-space: nowrap;
	background: ${(props) => props.bg || "#F3F4F6"};
	color: ${(props) => props.color || "#374151"};
`;

export const StatusText = styled.span`
	font-size: 14px;
	font-weight: 700;
	color: ${(props) => (props.active ? "#16A34A" : "#9CA3AF")};
`;

export const ActionButton = styled.button`
	border: none;
	border-radius: 8px;
	background-color: transparent;
	padding: 6px;
	cursor: pointer;
	color: ${COLORS.Primary};
	display: inline-flex;
	align-items: center;
	justify-content: center;

	&:hover {
		background-color: #eef2ff;
	}
`;

export const NameText = styled.div`
	font-size: 14px;
	font-weight: 700;
	color: #111827;
	cursor: pointer;
`;

export const EmailText = styled.div`
	font-size: 14px;
	font-weight: 500;
	color: #374151;
`;

export const AvatarCell = styled.div`
	display: flex;
	align-items: center;
`;

export const AntdModal = styled(Modal)`
	.ant-modal-content {
		border-radius: 10px;
	}

	.ant-modal-header {
		border-radius: 10px 10px 0 0;
	}

	.ant-modal-body {
		background-color: ${COLORS.LightGrey};
		padding: 1rem 5rem 1rem 5rem;
		border-radius: 0 0 10px 10px;
	}

	.ant-modal-footer {
		text-align: left;
		height: 80px;
	}
`;
